import { RecurringSubscriptionInterval } from '@jotta/grpc-connect-openapi/payment'
import { cn } from '@jotta/utils/css'
import { Button } from '@jotta/ui/Button'
import { t } from '@lingui/macro'

export function IntervalSwitch({
  interval,
  setInterval,
  className,
}: {
  interval: RecurringSubscriptionInterval
  setInterval: (interval: RecurringSubscriptionInterval) => void
  className?: string
}) {
  const intervals: RecurringSubscriptionInterval[] = [
    RecurringSubscriptionInterval.YEARLY_RECURRING,
    RecurringSubscriptionInterval.MONTHLY_RECURRING,
  ]
  const text = [t`Pay Yearly`, t`Pay Monthly`]
  return (
    <div
      className={cn(
        'flex w-fit items-center justify-between rounded-[38px] border border-light bg-primary p-1',
        className,
      )}
    >
      {intervals.map((i, idx) => {
        return (
          <Button
            key={i}
            className={cn(
              'label-sm w-auto whitespace-nowrap px-[14px] py-[6px] text-grey4',
              {
                'rounded-[40px] bg-upgrade-background text-black':
                  i === interval,
              },
            )}
            onClick={() => setInterval(i)}
          >
            {text[idx]}
          </Button>
        )
      })}
    </div>
  )
}
